import React, { useEffect, useState } from 'react'
import t from '~t'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { confirmEmail } from '~data/actions/user'

import { Helmet } from 'react-helmet'
import { Button, Preloader, Header, HeaderTitle as Title, Layout, ButtonRow, Alert } from '~ui';

export default function PageAccountConfirm() {
    const { token } = useParams()
    const dispatch = useDispatch()

    const [done, setDone] = useState(false)
    const [error, setError] = useState(null)

    useEffect(()=>{
        dispatch(confirmEmail({ token }, ()=>setDone(true), setError))
    }, [token])

    return (<>
        <Helmet><title>{t.s('emailConfirmation')}</title></Helmet>

        <Layout>
            {done ? (<>
                <Header data-fancy>
                    <Title>{t.s('emailConfirmed')}</Title>
                </Header>

                <ButtonRow>
                    <Button
                        as='a'
                        variant='primary'
                        data-block
                        href='/'>
                        {t.s('goHome')}
                    </Button>
                </ButtonRow>
            </>) : error ? (
                <Alert variant='danger'>
                    {error?.message || t.s('server')}
                </Alert>
            ) : (
                <Button variant='ghost' 
                    data-block
                    disabled>
                    <Preloader />
                    {t.s('emailConfirmation')}…
                </Button>
            )}
        </Layout>
    </>)
}
